/* eslint-disable no-undef */
import { IModule } from '@api/types/general';
import Tabs, { ITabItem } from '@components/tabs';
import Game from './game';
import Head from './head';
import useReduxState from '@hooks/useReduxState';
import styles from './panel.module.scss';
import { HIGH_ROOM_INDEX, LOW_ROOM_INDEX } from '@views/jackpot';
import useJackpotRoom from '@hooks/useJackpotRoom';

interface IGamePanelProps extends IModule {
    COLORS: string[];
}

const GamePanel = ({
    className = '',
    COLORS,
}: IGamePanelProps): JSX.Element | null => {
    const [{ rooms }] = useReduxState((state) => state.jackpot);
    const { setRoom } = useJackpotRoom();

    const lowRoom = rooms[LOW_ROOM_INDEX];
    const highRoom = rooms[HIGH_ROOM_INDEX];

    /* Components */

    const tabs: ITabItem[] = [
        {
            paneContent: <Game {...{ COLORS }} />,
            tab: {
                content: (
                    <Head
                        title={lowRoom.title}
                        bank={lowRoom.current_game.bank}
                        className={styles.panel__lowBank}
                    />
                ),
                onClick: () => setRoom(LOW_ROOM_INDEX),
            },
        },
        {
            paneContent: <Game {...{ COLORS }} />,
            tab: {
                content: (
                    <Head
                        title={highRoom.title}
                        bank={highRoom.current_game.bank}
                        className={styles.panel__highBank}
                    />
                ),
                onClick: () => setRoom(HIGH_ROOM_INDEX),
            },
        },
    ];

    return (
        <section {...{ className }}>
            <Tabs {...{ tabs }} color="blue-dark" alignment="center" />
        </section>
    );
};

export default GamePanel;
